import { get, post } from '@/util/auth'

export const getDevicePolicyAPI = (code: string) => get(`app/${code}/device-policy`)

export const postOrder = ({ order, phoneNumber }: { order: unknown; phoneNumber: string }) =>
  post('app/' + phoneNumber + '/device-policy/order', order)
